const routers = [
  {
    component: "AuthLayout",
    path: "/auth",
    name: "Login",
    exact: false,
    childrens: [
      {
        component: "Login",
        path: "/login",
        componentPath: "pages/Auth/Login",
        name: "Login",
        auth: false,
        exact: true,
      },
      {
        component: "SignUp",
        path: "/sign-up",
        componentPath: "pages/Auth/SignUp",
        name: "SignUp",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/",
    name: "Landing",
    exact: true,
    childrens: [
      {
        component: "LandingPage",
        path: "/",
        componentPath: "pages/Landing",
        name: "LandingPage",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-ug",
    name: "NeetUG",
    exact: false,
    childrens: [
      {
        component: "NeetUG",
        path: "/",
        componentPath: "pages/Landing/Exams/NeetUG",
        name: "NeetUG",
        auth: false,
        exact: true,
      },
      {
        component: "NeetCentersInfo",
        path: "/neet-center-info",
        componentPath: "pages/NeetCenters",
        name: "NeetCentersInfo",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-pg",
    name: "NeetPG",
    exact: false,
    childrens: [
      {
        component: "NeetPG",
        path: "/",
        componentPath: "pages/Landing/Exams/NeetPG",
        name: "NeetPG",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-mds",
    name: "NeetMDS",
    exact: false,
    childrens: [
      {
        component: "NeetMDS",
        path: "/",
        componentPath: "pages/Landing/Exams/NeetMDS",
        name: "NeetMDS",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/inicet",
    name: "Inicet",
    exact: false,
    childrens: [
      {
        component: "Inicet",
        path: "/",
        componentPath: "pages/Landing/Exams/Inicet",
        name: "Inicet",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/dnb-pdcet",
    name: "DnbPDCET",
    exact: false,
    childrens: [
      {
        component: "DnbPDCET",
        path: "/",
        componentPath: "pages/Landing/Exams/DnbPDCET",
        name: "DnbPDCET",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-ss",
    name: "NeetSS",
    exact: false,
    childrens: [
      {
        component: "NeetSS",
        path: "/",
        componentPath: "pages/Landing/Exams/NeetSS",
        name: "NeetSS",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-counselling-process",
    name: "NeetCounsellingProcess",
    exact: false,
    childrens: [
      {
        component: "NeetCounsellingProcess",
        path: "/",
        componentPath: "pages/Landing/Process",
        name: "NeetCounsellingProcess",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/top-colleges-for-neet",
    name: "TopCollegesForNeet",
    exact: false,
    childrens: [
      {
        component: "TopCollegesForNeet",
        path: "/",
        componentPath: "pages/Landing/CollegesForNeet",
        name: "TopCollegesForNeet",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-cut-off",
    name: "NeetCutOff",
    exact: false,
    childrens: [
      {
        component: "NeetCutOff",
        path: "/",
        componentPath: "pages/Landing/NeetCutOff",
        name: "NeetCutOff",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-ug-counselling-date",
    name: "NeetUGCounsellingDate",
    exact: false,
    childrens: [
      {
        component: "NeetUGCounsellingDate",
        path: "/",
        componentPath: "pages/Landing/CounsellingDate",
        name: "NeetUGCounsellingDate",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-subject",
    name: "NeetSubject",
    exact: false,
    childrens: [
      {
        component: "NeetSubject",
        path: "/",
        componentPath: "pages/Landing/NeetSubject",
        name: "NeetSubject",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/institutes",
    name: "InstitutePages",
    exact: false,
    childrens: [
      {
        component: "InstituteListPage",
        path: "/",
        name: "InstituteList",
        componentPath: "pages/Landing/Explore/InstituteList",
        exact: true,
        auth: false,
      },
      {
        component: "InstituteDetails",
        path: "/:slug",
        name: "InstituteDetailsComp",
        componentPath: "pages/Landing/Explore/InstituteDetails",
        exact: true,
        auth: false,
        skipSiteMap: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/videos",
    name: "Videos",
    exact: false,
    childrens: [
      {
        component: "VideosList",
        path: "/",
        componentPath: "pages/Landing/Explore/VideosList",
        name: "VideosList",
        auth: false,
        exact: true,
      },
      {
        component: "VideoPlayer",
        path: "/:slug",
        name: "VideoPlayer",
        componentPath: "pages/Landing/Explore/VideoPlayer",
        exact: true,
        auth: false,
        skipSiteMap: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/packages",
    name: "Packages",
    exact: false,
    childrens: [
      {
        componet: "Packages",
        path: "/",
        componentPath: "pages/Landing/Packages",
        name: "Packages",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/contact-us",
    name: "ContactUs",
    exact: false,
    childrens: [
      {
        component: "ContactUs",
        path: "/",
        componentPath: "pages/Landing/ContactUs",
        name: "ContactUs",
        auth: false,
        exact: true,
      },
    ],
  },
  // {
  //   component: "LandingLayout",
  //   path: "/ambassador",
  //   name: "Ambassador",
  //   exact: false,
  //   childrens: [
  //     {
  //       component: "Ambassador",
  //       path: "/",
  //       componentPath: "pages/Landing/Ambassador",
  //       name: "Ambassador",
  //       auth: false,
  //       exact: true,
  //       skipSiteMap: true,
  //     },
  //   ],
  // },
  {
    component: "LandingLayout",
    path: "/influencer-program",
    name: "InfluencerProgram",
    exact: false,
    childrens: [
      {
        component: "InfluencerProgram",
        path: "/",
        componentPath: "pages/Landing/InfluencerProgram",
        name: "InfluencerProgram",
        auth: false,
        exact: true,
        skipSiteMap: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/testimonials",
    name: "TestimonialsWall",
    exact: false,
    childrens: [
      {
        component: "TestimonialsWallComp",
        path: "/",
        componentPath: "pages/Landing/TestimonialsWall",
        name: "TestimonialsWall",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-ug-promo",
    name: "UgPromotionalPage",
    exact: false,
    childrens: [
      {
        component: "PromotionalPageComp",
        path: "/",
        componentPath: "pages/Landing/UgPromotionalPage",
        name: "UgPromotionalPage",
        auth: false,
        exact: true,
        skipSiteMap: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-pg-promo",
    name: "PgPromotionalPage",
    exact: false,
    childrens: [
      {
        component: "PgPromotionalPageComp",
        path: "/",
        componentPath: "pages/Landing/PgPromotionalPage",
        name: "PgPromotionalPage",
        auth: false,
        exact: true,
        skipSiteMap: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/package-policy",
    name: "PackagePolicy",
    exact: false,
    childrens: [
      {
        component: "PackagePolicy",
        path: "/",
        componentPath: "pages/Landing/PackagePolicy",
        name: "PackagePolicy",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    exact: false,
    childrens: [
      {
        component: "PrivacyPolicy",
        path: "/",
        componentPath: "pages/Landing/PrivacyPolicy",
        name: "PrivacyPolicy",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/terms-and-conditions",
    name: "TermsOfService",
    exact: false,
    childrens: [
      {
        component: "TermsOfService",
        path: "/",
        componentPath: "pages/Landing/TermsOfService",
        name: "TermsOfService",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/careers",
    exact: false,
    childrens: [
      {
        component: "Careers",
        path: "/",
        name: "Careers",
        componentPath: "pages/Careers",
        exact: false,
        auth: false,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/jobs",
    exact: false,
    childrens: [
      {
        component: "Jobs",
        path: "/",
        name: "Jobs",
        componentPath: "pages/Jobs",
        exact: false,
        auth: false,
        skipSiteMap: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/neet-college-predictor",
    name: "Predictor",
    exact: false,
    childrens: [
      {
        component: "PredictorForm",
        path: "/neet-college-predictor-2024",
        componentPath: "pages/Predictor/Form",
        name: "PredictorForm",
        auth: false,
        exact: true,
      },
      {
        component: "PredictorList",
        path: "/neet-ug-college-predictor-2024/results",
        componentPath: "pages/Predictor/List",
        name: "PredictorList",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/blogs",
    name: "BlogsPages",
    exact: false,
    childrens: [
      {
        component: "BlogsListPage",
        path: "/",
        name: "BlogsList",
        componentPath: "pages/Landing/Blogs/BlogsList",
        exact: true,
        auth: false,
      },
      {
        component: "BlogsDetails",
        path: "/:slug",
        name: "BlogsDetails",
        componentPath: "pages/Landing/Blogs/BlogsDetails",
        exact: true,
        auth: false,
        skipSiteMap: true,
      },
    ],
  },
  {
    component: "LandingLayout",
    path: "/about-us",
    exact: false,
    childrens: [
      {
        component: "AboutUsPage",
        path: "/",
        name: "AboutUs",
        componentPath: "pages/Landing/AboutUs",
        exact: false,
        auth: false,
      },
    ],
  },
  {
    component: "NavigationLayout",
    path: "/portal",
    name: "Dashboard",
    exact: false,
    childrens: [
      {
        component: "Dashboard",
        path: "/",
        componentPath: "pages/Dashboard",
        name: "Dashboard",
        auth: true,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard",
        name: "Dashboard",
        auth: true,
        exact: true,
      },
      {
        component: "Videos",
        path: "/videos",
        componentPath: "pages/Videos",
        name: "Videos",
        auth: true,
        exact: true,
      },
      {
        component: "VideoPlayer",
        path: "/videos/:slug",
        componentPath: "pages/VideoPlayer",
        name: "VideoPlayer",
        auth: true,
        exact: true,
        skipSiteMap: true,
      },
      {
        component: "AnnouncementEvents",
        path: "/announcements-events",
        componentPath: "pages/AnnouncementsAndEvents",
        name: "Announcements-Events",
        auth: true,
        exact: true,
      },
      {
        component: "Allotments",
        path: "/allotments",
        componentPath: "pages/Allotments",
        name: "Allotments",
        auth: true,
        exact: true,
      },
      {
        component: "ClosingRanks",
        path: "/closingranks",
        componentPath: "pages/ClosingRanks",
        name: "ClosingRanks",
        auth: true,
        exact: true,
      },
      {
        component: "ChoiceTable",
        path: "/choiceTable",
        componentPath: "pages/ChoiceTable",
        name: "ChoiceTable",
        auth: true,
        exact: true,
      },
      {
        component: "ChoiceList",
        path: "/choiceList",
        componentPath: "pages/ChoiceList",
        name: "ChoiceList",
        auth: true,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/profile",
        componentPath: "pages/MyProfile",
        name: "MyProfile",
        auth: true,
        exact: true,
      },
      {
        component: "MyPackage",
        path: "/mypackage",
        componentPath: "pages/MyPackage",
        name: "MyPackage",
        auth: true,
        exact: true,
      },
      {
        component: "PackageScreen",
        path: "/packages",
        componentPath: "pages/PackageScreen",
        name: "Packages",
        auth: true,
        exact: true,
      },
      {
        component: "FAQ",
        path: "/faq",
        componentPath: "pages/FAQ",
        name: "FAQ",
        auth: true,
        exact: true,
      },
      {
        component: "Resources",
        path: "/resources",
        componentPath: "pages/Resources",
        name: "Resources",
        auth: true,
        exact: true,
      },
      {
        component: "FeeStipendBond",
        path: "/feestipendbond",
        componentPath: "pages/FeeStipendBond",
        name: "FeeStipendBond",
        auth: true,
        exact: true,
      },
      {
        component: "AllotmentMapping",
        path: "/allotmentmapping",
        name: "AllotmentMapping",
        componentPath: "pages/AllotmentMapping",
        exact: true,
        auth: true,
      },
      {
        component: "SeatMatrix",
        path: "/seatmatrix",
        componentPath: "pages/SeatMatrix",
        name: "SeatMatrix",
        auth: true,
        exact: true,
      },
      {
        component: "RankScan",
        path: "/rankscan",
        componentPath: "pages/RankScan",
        name: "RankScan",
        auth: true,
        exact: true,
      },
      {
        component: "PaymentSummary",
        path: "/paymentsummary",
        componentPath: "pages/PaymentSummary",
        name: "PaymentSummaryPage",
        auth: true,
        exact: true,
      },
      {
        component: "Referral",
        path: "/referral",
        componentPath: "pages/Referral",
        name: "ReferralPage",
        auth: true,
        exact: true,
      },
      {
        component: "SeatIncrease",
        path: "/seatIncrease",
        componentPath: "pages/SeatIncrease",
        name: "SeatIncrease",
        auth: true,
        exact: true,
      },
      {
        component: "Counselling",
        path: "/counsellings",
        name: "CounsellingComp",
        componentPath: "pages/Counselling",
        exact: true,
        auth: true,
      },
      {
        component: "CounsellingDetails",
        path: "/counsellings/:slug",
        name: "CounsellingDetailsComp",
        componentPath: "pages/CounsellingDetails",
        exact: true,
        auth: true,
      },
      {
        component: "University",
        path: "/universities",
        name: "UniversityComp",
        componentPath: "pages/University",
        exact: true,
        auth: true,
      },
      {
        component: "UniversityDetails",
        path: "/universities/:slug",
        name: "UniversityDetailsComp",
        componentPath: "pages/UniversityDetails",
        exact: true,
        auth: true,
      },
      {
        component: "Institute",
        path: "/institutes",
        name: "InstituteComp",
        componentPath: "pages/Institute",
        exact: true,
        auth: true,
      },
      {
        component: "InstituteDetails",
        path: "/institutes/:slug",
        name: "InstituteDetailsComp",
        componentPath: "pages/InstituteDetails",
        exact: true,
        auth: true,
      },
      {
        component: "Course",
        path: "/courses",
        name: "CourseComp",
        componentPath: "pages/Course",
        exact: true,
        auth: true,
      },
    ],
  },
  {
    component: "NotFoundLayout",
    path: "/error",
    exact: false,
    childrens: [
      {
        component: "NotFoundLayout",
        path: "/page-not-found",
        name: "NotFoundLayout",
        componentPath: "pages/PageNotFound",
        exact: false,
        skipSiteMap: true,
      },
    ],
  },

  {
    component: "EventLayout",
    path: "/neetly-done-2025",
    name: "NeetlyDone",
    exact: false,
    childrens: [
      {
        component: "NeetlyDone",
        path: "/",
        name: "NeetlyDone",
        componentPath: "pages/Events/NeetlyDone",
        exact: false,
        auth: false,
      },
    ],
  },
  {
    component: "EventLayout",
    path: "/neetly-terms-and-conditions",
    name: "TermsAndConditions",
    exact: false,
    childrens: [
      {
        component: "TermsAndConditionsPage",
        path: "/",
        name: "TermsAndConditions",
        componentPath: "pages/Events/NeetlyDone/TermsAndConditions",
        exact: false,
        auth: false,
      },
    ],
  },
];
module.exports = routers; // instead of export default
